import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Flex, Text } from '@chakra-ui/react';
export const NavigationUserMenuHeader = ({ title, subTitle }) => {
    return (_jsxs(Flex, { flexDir: 'column', px: 6, pt: 2, children: [_jsx(Text, { variant: 'heading6', children: title }), subTitle && subTitle.length > 0 && (_jsx(Text, { variant: 'label', color: 'neutral400', noOfLines: 1, children: subTitle })), _jsx(Divider, { mb: 2, mt: 3 })] }));
};
